<template>
  <div class="bg--gray">
      <div class="container">
        <h1 class="my-5">{{ msg }}</h1>
          <div class="panel m-0">
              <h2 class="text-left">Ihre persönlichen Angaben</h2>
              <br/>

              <form>
                  <div class="form-group row">
                      <label for="person" class="col-sm-2 text-left">Person:</label>
                      <div class="col-sm-10">
                          <input type="text" class="form-control form-control-sm" autofocus id="person" placeholder="Person">
                      </div>
                  </div>
                  <div class="form-group row">
                      <label for="person" class="col-sm-2">Geschlecht:</label>
                      <div class="col-sm-10 checkbox-wrapper">
                          <div class="custom-control custom-checkbox">
                              <input type="checkbox" class="custom-control-input" id="customCheck1">
                              <label class="custom-control-label" for="customCheck1">Check this custom checkbox</label>
                          </div>

                      </div>
                  </div>
                  <div class="form-group row">
                      <label for="person" class="col-sm-2">Geschlecht:</label>
                      <div class="col-sm-10 checkbox-wrapper">
                        <div class="custom-control custom-radio">
                          <input type="radio" id="customRadio1" name="customRadio" class="custom-control-input">
                          <label class="custom-control-label" for="customRadio1">Toggle this custom radio</label>
                        </div>
                        <div class="custom-control custom-radio">
                          <input type="radio" id="customRadio2" name="customRadio" class="custom-control-input">
                          <label class="custom-control-label" for="customRadio2">Or toggle this other custom radio</label>
                        </div>
                      </div>
                  </div>

                  <div class="form-group row">
                      <label for="lang" class="col-sm-2">Sprache:</label>
                      <div class="col-sm-10">
                          <select class="custom-select" id="lang">
                              <option value="Deutsch" selected>Deutsch</option>
                              <option value="Englisch">Englisch</option>
                          </select>
                      </div>
                  </div>
                  <div class="form-group row">
                      <label for="inputEmail3" class="col-sm-2 col-form-label">Email: </label>
                      <div class="col-sm-10">
                          <input type="email" class="form-control" id="inputEmail3" disabled placeholder="Email">
                      </div>
                  </div>
                  <div class="form-group row">
                      <label for="inputPassword3" class="col-sm-2 col-form-label">Password:</label>
                      <div class="col-sm-10">
                          <input type="password" class="form-control is-invalid" id="inputPassword3" placeholder="Password">
                          <div class="invalid-feedback">
                            Please write strong password.
                          </div>
                      </div>
                  </div>
                  <div class="form-group row align-items-center">
                      <label for="inputPassword3" class="col-sm-2 col-form-label">Upload files:</label>
                      <div class="col-sm-10">
                        <div class="upload-input__container">
                          <span class="upload-input__title">Foto(150x150):</span>
                          <label class="upload-input__label" for="upload-photo">

                            <svg width="45px" height="31px" viewBox="0 0 45 31" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" fill-opacity="0.26" font-family="material" font-size="45" font-weight="normal">
                                <g id="Text-Fields" transform="translate(-1026.000000, -570.000000)" fill="#231F20">
                                  <g id="Group" transform="translate(739.500000, 519.750000)">
                                    <g id="Foto" transform="translate(0.000000, 39.757890)">
                                      <text id="cloud_upload---material">
                                        <tspan x="286.5" y="41.2514433"></tspan>
                                      </text>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </svg>
                            <span>Upload</span>

                          </label>
                          <input type="file" class="upload-input" id="upload-photo">
                        </div>
                      </div>
                  </div>
                  <div class="form-group row">
                      <div class="col-sm-10">
                          <button type="submit" class="btn btn-primary">Sign in</button>
                      </div>
                  </div>
              </form>

          </div>
      </div>

  </div>
</template>

<script>
    export default {
      name: 'TextForms',
      data () {
        return {
          msg: 'TextForms'
        }
      }
    }
</script>

<style lang="scss">
  @import "./../assets/scss/_base.scss";
  @import "./../assets/scss/variables";

    .form-check-title {
        padding-left: 1.5rem;
    }

  .form-group {
      &.row {
          margin-bottom: 3rem;
      }

      > label {
          margin-bottom: 0;
          text-align: left;
      }
  }

    /*.checkbox-wrapper {*/
        /*text-align: left;*/
        /*.form-check {*/
            /*display: inline-block;*/
            /*padding-left: 0;*/
            /*&:last-child {*/
                /*margin-left: 1.5rem;*/
            /*}*/

        /*}*/
    /*}*/


    .custom-select {
        border: 0;
        border-bottom: 1px solid;
        height: auto;
        border-radius: 0;
        padding-left: 0;
        border-bottom: 1px solid rgba(0,0,0,0.25);
    }

  .upload-input {
    opacity: 0;
    z-index: -1;
    position: absolute;

    &__container {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }

    &__label {
      cursor: pointer;
      display: flex;
      flex-direction: column;
      border: 1px dashed $alert-dark-gray;
      justify-content: center;
      align-items: center;
      padding: 0.5rem;
      flex-basis: 80%;
    }

    &__title {
      flex-basis: 20%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/TextForms.vue